import {
    LOGIN_PRODUCT_ADMIN,
    LOGIN_PRODUCT_ADMIN_SUCCESS,
    LOGOUT_PRODUCT_ADMIN,
    LOGOUT_PRODUCT_ADMIN_SUCCESS,
    API_ERROR,
    GET_PRODUCT_ADMIN_PROFILE,
    GET_PRODUCT_ADMIN_PROFILE_SUCCESS,
    GET_PRODUCT_ADMIN_PROFILE_FAIL,
} from "./actionTypes"

export const loginProductAdmin = (productAdmin, history) => {
    return {
        type: LOGIN_PRODUCT_ADMIN,
        payload: { productAdmin, history },
    }
}

export const loginProductAdminSuccess = auth_product_admin => {
    return {
        type: LOGIN_PRODUCT_ADMIN_SUCCESS,
        payload: auth_product_admin,
    }
}

export const logoutProductAdmin = history => {
    return {
        type: LOGOUT_PRODUCT_ADMIN,
        payload: { history },
    }
}

export const logoutProductAdminSuccess = () => {
    return {
        type: LOGOUT_PRODUCT_ADMIN_SUCCESS,
        payload: {},
    }
}

export const apiError = error => {
    return {
        type: API_ERROR,
        payload: error,
    }
}

export const getProductAdminProfile = () => {
    return {
        type: GET_PRODUCT_ADMIN_PROFILE
    }
}

export const getProductAdminProfileSuccess = productAdmin => {
    return {
        type: GET_PRODUCT_ADMIN_PROFILE_SUCCESS,
        payload: productAdmin,
    }
}

export const getUserProfileFail = error => {
    return {
        type: GET_PRODUCT_ADMIN_PROFILE_FAIL,
        payload: error,
    }
}
